import DynamicYieldAPI from 'api/DynamicYield';
import { SLOT_CLICK, CLICK } from 'api/DynamicYield/constants';
import IpAPI from 'api/IP';
import { SHOP_IDS } from 'constants/shops';
import ACTIONS from 'state/constants';
import DataDogLogs from 'utils/DataDogLogs';
import Log from 'utils/Log';
import Settings from 'utils/Settings';

export const fetchPersonalizations = selector => async dispatch => {
  if (Settings.shopID === SHOP_IDS.US) {
    dispatch({ type: ACTIONS.FETCH_PERSONALIZATIONS_REQUEST, payload: { selector } });

    const start = Date.now();
    let duration;
    let finished;
    try {
      const userIp = await IpAPI.getUserIP();
      const experience = await DynamicYieldAPI.choose(selector, userIp);

      finished = Date.now();
      duration = finished - start;
      if (experience?.data?.choices?.length > 0) {
        DataDogLogs.info(
          `Selectors: ${JSON.stringify(selector.names)} matched existing DY campaigns`,
          {
            browserTelemetry: {
              start,
              duration,
              finished,
            },
          }
        );
        dispatch({
          type: ACTIONS.FETCH_PERSONALIZATIONS_SUCCESS,
          payload: {
            choices: experience.data.choices,
            cookies: experience.data.cookies,
            selector,
            userIp,
          },
        });
      } else {
        DataDogLogs.info(
          `Selectors: ${JSON.stringify(selector.names)} did not match any existing DY campaign`,
          {
            browserTelemetry: {
              start,
              duration,
              finished,
            },
          }
        );
        dispatch({ type: ACTIONS.FETCH_PERSONALIZATIONS_FAILURE, payload: { selector } });
      }
    } catch (error) {
      finished = Date.now();
      duration = finished - start;
      DataDogLogs.error(
        `DY Experience Fetch Failed! selectors:${JSON.stringify(selector.names)}`,
        {
          browserTelemetry: {
            start,
            duration,
            finished,
          },
        },
        error
      );
      dispatch({ type: ACTIONS.FETCH_PERSONALIZATIONS_FAILURE, payload: { error, selector } });
    }
  }
};

export const trackDYRecsClick =
  ({ eventCategory, eventAction, eventLabel, slotId }) =>
  async dispatch => {
    dispatch({
      type: ACTIONS.TRACK_DY_RECS_CLICK,
      eventCategory,
      eventAction,
      eventLabel,
    });

    try {
      const clickData = [
        {
          type: SLOT_CLICK,
          slotId,
        },
      ];

      await DynamicYieldAPI.reportClick(clickData);
    } catch (error) {
      Log.error(error, `Failed to send DY Engagement Click Report for Recommendations!`);
    }
  };

export const reportDYRecsClick = slotId => async dispatch => {
  dispatch({
    type: ACTIONS.REPORT_DY_RECS_CLICK,
    payload: { slotId },
  });
};

export const trackEngagementClick =
  ({
    eventCategory = 'DY Experiment',
    eventAction = '',
    eventLabel = '',
    eventValue = '',
    dyDecisionId,
    dyVariationId,
  }) =>
  async dispatch => {
    dispatch({
      type: ACTIONS.TRACK_EVENT,
      eventCategory: eventCategory || 'DY Experiment',
      eventAction,
      eventLabel,
      eventValue,
    });
    if (dyDecisionId) {
      try {
        const clickData = {
          type: CLICK,
          decisionId: dyDecisionId,
        };

        if (dyVariationId) {
          clickData.variations = [dyVariationId];
        }

        await DynamicYieldAPI.reportClick([clickData]);
      } catch (error) {
        Log.error(error, `Failed to send DY Engagement Click`);
      }
    }
  };

export const trackDYAPICampaignAssignment = analyticsData => dispatch => {
  dispatch({
    type: ACTIONS.TRACK_DY_API_CAMPAIGN_ASSIGNMENT,
    eventCategory: 'DY API Campaign Assignment',
    eventAction: analyticsData?.campaignName,
    eventLabel: `${analyticsData?.experienceName} (${analyticsData?.variationName})`,
  });
};
